import React, { useState } from "react";
import Radio from "./Radio";
import InputField from "./InputField";
import Slider from "./Slider";
/*

* React FC
  
*/

const FormInput = props => {
  const {
    updateFieldValue,
    selectedCalcData,
    currentFieldValue,
    updateSliderValue
  } = props;

  const getField = fieldValue => {
    switch (fieldValue.type) {
      case "input":
        return (
          <InputField
            fieldValue={fieldValue}
            updateFieldValue={updateFieldValue}
            currentFieldValue={currentFieldValue}
          />
        );
      case "slider":
        return (
          <Slider
            fieldValue={fieldValue}
            updateSliderValue={updateSliderValue}
            currentFieldValue={currentFieldValue}
          />
        );
      case "radio":
        return (
          <Radio
            fieldValue={fieldValue}
            updateFieldValue={updateFieldValue}
            currentFieldValue={currentFieldValue}
          />
        );
      default:
        return null;
    }
  };
  return (
    <div className="flex space-between wrap inputContainer">
      {selectedCalcData.fieldValues.map((field, i) => getField(field))}
      <style jsx>{`
        .inputContainer{
          padding:16px;
        }      
        @media screen and (max-width: 600px) {
          .inputContainer {
            justify-content: flex-start;
          }
      `}</style>
    </div>
  );
};

export default FormInput;
